import { render, staticRenderFns } from "./ScoreApproval.vue?vue&type=template&id=1989e544&"
import script from "./ScoreApproval.vue?vue&type=script&lang=js&"
export * from "./ScoreApproval.vue?vue&type=script&lang=js&"
import style0 from "./ScoreApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports